import React from "react";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const VehicleTypeForm = ({
  register,
  errors,
  setValue,
  getValues,
  clearErrors,
}: any) => {
  return (
    <div className={tw`grid grid-cols-1 md:grid-cols-2 gap-x-4 mx-4`}>
      <TextField
        label={"Name"}
        register={register("name")}
        errors={errors?.name}
      />
    </div>
  );
};

export default VehicleTypeForm;
